import { EditabledShortcut } from '../../../models/types';
import { InsertPosition } from '../../../services/dto/insert-position';
import { RowType } from '../../../services/dto/row-type';

// `Alt` + a layout-independent `KeyboardEvent.code`, plus an arrow (↑ ↓ →) for position-aware actions.

export const EDITABLED_SHORTCUTS: EditabledShortcut[] = [
  { action: 'addLine', code: 'KeyL', hasPosition: true },
  { action: 'addChapter', code: 'KeyK', hasPosition: true },
  { action: 'addComment', code: 'KeyM', hasPosition: true },
  { action: 'hideLine', code: 'KeyH' },
  { action: 'deleteLine', code: 'KeyR' },
  { action: 'selectForMove', code: 'KeyX' },
  { action: 'moveTo', code: 'KeyV', hasPosition: true },
  { action: 'selectForDuplicate', code: 'KeyC' },
  { action: 'duplicateTo', code: 'KeyB', hasPosition: true },
  { action: 'convertLine', code: 'Digit1', targetType: RowType.Chapter },
  { action: 'convertLine', code: 'Digit2', targetType: RowType.Item },
  { action: 'convertLine', code: 'Digit3', targetType: RowType.Comment },
];

/** Maps the third-key arrow (`KeyboardEvent.code`) to an insert position. */
export const ARROW_POSITION: Record<string, InsertPosition> = {
  ArrowDown: InsertPosition.Below,
  ArrowRight: InsertPosition.Inside,
  ArrowUp: InsertPosition.Above,
};

// Hierarchical mirror of the keymap: an entry with `children` but no `combo` is a section header.

export interface EditabledShortcutHint {
  children?: EditabledShortcutHint[];
  combo?: string;
  label: string;
}

const positionChildren = (combo: string): EditabledShortcutHint[] => [
  { combo: `${combo} ↑`, label: 'grid.editabled.position.above' },
  { combo: `${combo} ↓`, label: 'grid.editabled.position.below' },
  { combo: `${combo} →`, label: 'grid.editabled.position.inside' },
];

export const EDITABLED_SHORTCUT_HINTS: EditabledShortcutHint[] = [
  { children: positionChildren('Alt+L'), label: 'grid.editabled.context.add-line' },
  { children: positionChildren('Alt+K'), label: 'grid.editabled.context.add-chapter' },
  { children: positionChildren('Alt+M'), label: 'grid.editabled.context.add-comment' },
  { combo: 'Alt+X', label: 'grid.editabled.context.select-for-move' },
  { children: positionChildren('Alt+V'), label: 'grid.editabled.context.move-here' },
  { combo: 'Alt+C', label: 'grid.editabled.context.select-for-duplicate' },
  { children: positionChildren('Alt+B'), label: 'grid.editabled.context.duplicate-here' },
  { combo: 'Alt+H', label: 'grid.editabled.context.hide' },
  { combo: 'Alt+R', label: 'grid.editabled.context.delete' },
  {
    children: [
      { combo: 'Alt+1', label: 'grid.editabled.row-type.chapter' },
      { combo: 'Alt+2', label: 'grid.editabled.row-type.item' },
      { combo: 'Alt+3', label: 'grid.editabled.row-type.comment' },
    ],
    label: 'grid.editabled.context.convert',
  },
];
